
import { OperationWithCommand } from '../models/operation-with-command.model';
import { Dictionary } from '../../../types/dictionary.type';
import { pipe } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OperationType, Operation } from '..';

export const filterOperations = <T extends Operation>(operationTypeInstance: { new(): T, operationTypeStatic: OperationType}) => {
    const operator = pipe(
        map((operations: Dictionary<OperationType, Operation>) => operations[operationTypeInstance.operationTypeStatic] as Operation),
        isNotNullOrUndefined(),
        isOperationWithCommand(),
        filter(operation => operation instanceof operationTypeInstance),
        map(item => item as T),
    );

    return operator;
};

function isOperationWithCommand() {
    const operator = pipe(
        filter(inputIsOperationWithCommand)
    );
    return operator;
}

function inputIsOperationWithCommand(operation: Operation): operation is OperationWithCommand {
  return operation.currentCommand !== undefined && operation.currentCommand !== null;
}


function inputIsNotNullOrUndefined<T>(input: null | undefined | T): input is T {
    return input !== null && input !== undefined;
}

function isNotNullOrUndefined<T>() {
    const operator = pipe(
        filter<T>(inputIsNotNullOrUndefined)
    );
    return operator;
}
